<div id="e-invoicing-banner" *ngIf="rcuId" data-testid="e-invoicing-card">
  <div class="banner-text">
    <p class="banner-title">Facturation électronique</p>
    <p class="banner-body">Déclarez votre plateforme de dématérialisation pour être prêt pour la réforme.</p>
    <p class="banner-note">Ce message reste affiché même si vous avez déjà cliqué et rempli le formulaire&nbsp;: si vous l'avez déjà fait, vous n'avez rien à faire de plus.</p>
  </div>
  <a id="e-invoicing-link" [href]="eInvoicingUrl" target="_blank" rel="noopener"
    data-testid="e-invoicing-link">Déclarer ma plateforme</a>
</div>

<fs-message-card cardClass="alert" *ngIf="lateBillsNb" data-testid="message-card">
  <div *ngIf="lateBillsNb === 1" header> 1 facture en retard </div>
  <div *ngIf="lateBillsNb > 1" header> {{ lateBillsNb }} factures en retard </div>
  <div body> SeLoger peut vous accompagner pour trouver une solution,
    <a id="contact-link" [routerLink]="['/infos-contact']" data-testid="message-card-link">contactez-nous</a>.
  </div>
  <div action-button>
    <button *ngIf="lateBillsNb === 1" class="ui-btn action-button" data-testid="message-card-button" [routerLink]="['/balance-outstanding']">
      Régler la facture
    </button>
    <button *ngIf="lateBillsNb > 1" class="ui-btn action-button" data-testid="message-card-button" [routerLink]="['/balance-outstanding']">
      Régler les factures
    </button>
  </div>
</fs-message-card>

<div id="home-container">
  <h1>Bienvenue sur votre espace financier</h1>

  <p>Vous pouvez y effectuer les démarches suivantes</p>

  <div class="options">
    <button class="action" *apply-access-rights="rights.Payment" [routerLink]="['/bill-asset']"
      data-testid="home-link-bill-asset" [routerLinkActive]="['is-active']">
      <div class="title">
        <p>Factures et avoirs</p>
      </div>
      <div class="img">
        <span uiSvg source="assets/images/img-home-factures"></span>
      </div>
    </button>
    <button class="action" *apply-access-rights="[rights.Payment, rights.Cart]" [routerLink]="['/balance-outstanding']"
      data-testid="home-link-payment" [routerLinkActive]="['is-active']">
      <div class="title">
        <p>Paiement en ligne</p>
      </div>
      <div class="img">
        <span uiSvg source="assets/images/img-home-paiement"></span>
      </div>
    </button>
    <button class="action" *apply-access-rights="rights.Payment" [routerLink]="['/payment-means']"
      data-testid="home-link-payment-means" [routerLinkActive]="['is-active']">
      <div class="title">
        <p>Moyens de paiement</p>
      </div>
      <div class="img">
        <span uiSvg source="assets/images/img-home-payment-means"></span>
      </div>
    </button>
    <button class="action" [routerLink]="['/infos-contact']" data-testid="home-link-contact-us"
      [routerLinkActive]="['is-active']">
      <div class="title">
        <p>Services de facturation et recouvrement</p>
      </div>
      <div class="img">
        <span uiSvg source="assets/images/img-home-contact-services"></span>
      </div>
    </button>
  </div>

  <div class="info-creditors">
    <p>Ces opérations peuvent être effectuées pour tous vos créanciers</p>
    <ul>
      <li><b>DCF</b> (Digital Classifieds France, société du Groupe SeLoger)</li>
      <li><b>Webimm</b> (SeLoger bureaux & commerces)</li>
    </ul>
  </div>
</div>
